<template>
  <div class="padding">
    <div v-if="loading">
      <QuizJoinGameForm v-if="isAudienceFormShowing" @joinGame="handleJoinGame" />

      <div v-if="(!$store.state.presentation.audiencePacing && $store.state.presentation.presenting || $store.state.presentation.audiencePacing) && !isAudienceFormShowing">
        <transition name="slide-fade">
          <div v-if="$store.state.slide.quizStatus == QuizStatuses.LOBBY_SCREEN && !result.id" class="text-center">
            <div class="avatar-bubble">
              <div class="bubble" />
              <span
                class=" layout center horizontal center-justified animate__pulse animate__faster animate__animated animate__infinite"
              >{{ $store.state.audienceEmoji }}</span>
            </div>

            <div class="mb-5">
              <div class="mb-2 lobby-title">
                <strong>{{ $t("getReady", { msg: $store.state.audienceName }) }}</strong>
              </div>
              <div v-if="$store.state.presentation.teamPlay">
                <span
                  class="mr-1"
                  v-html="$t('youAreIn', { msg: `<strong>${chosenTeam.name}</strong>` })"
                />
                <span v-if="editTeamQuiz">
                  <span>(</span>
                  <span
                    @click="changeQuizTeam()"
                    class="change-team d-inline-block"
                  >
                    {{ $t('changeTeam') }}
                  </span>
                  <span>)</span>
                </span>
              </div>
            </div>

            <QuizCounter />

            <div class="mb-2" v-if="$store.state.slide.fastAnswerGetMorePoint">
              {{ $t("fasterGetMorePointsRule") }}
            </div>

            <div class="mb-2" v-if="!$store.state.slide.fastAnswerGetMorePoint">
              {{ $t("correctAnswerGetMaxPointTitle") }}
            </div>

            <div class="mb-2 des-small" v-if="!$store.state.slide.fastAnswerGetMorePoint">
              {{ $t("correctAnswerGetMaxPointDetail") }}
            </div>
          </div>
        </transition>
        <transition name="slide-fade">
          <div v-if="$store.state.slide.quizStatus == QuizStatuses.RULE_SCREEN && !result.id" class="text-center">

            <QuizCounter />

            <p
              v-if="$store.state.slide.fastAnswerGetMorePoint"
              class="mb-3 note-point"
            >
              {{ $t("fasterGetMorePointsRule") }}
            </p>
            <p
              v-if="!$store.state.slide.fastAnswerGetMorePoint"
              class="mb-3 note-point"
            >
              {{ $t("correctAnswerGetMaxPointTitle") }}
            </p>

            <div class="icon-step-2">
              <i
                class="fas fa-stopwatch fa-3x animate__animated animate__tada animate__delay-1s"
                v-if="$store.state.slide.fastAnswerGetMorePoint"
              />
            </div>
            <p
              v-if="!$store.state.slide.fastAnswerGetMorePoint"
              class="mb-3 small-note-point"
            >
              {{ $t("correctAnswerGetMaxPointDetail") }}
            </p>
          </div>
        </transition>
        <div>
          <div
            class="text-center step-4"
            v-if="($store.state.slide.quizStatus == QuizStatuses.COUNTDOWN_5S_SCREEN && !isAlreadyAnswered)
              || ($store.state.slide.quizStatus == QuizStatuses.QUESTION_SCREEN && !isAlreadyAnswered) || $store.state.slide.quizStatus == QuizStatuses.RESULT_SCREEN"
          >
            <h2
              class="mt-0 text-left slide-title-style"
              :inner-html.prop="$store.state.slide.title | sanitize(false)"
            />
            <p
              class="mb-3 text-left title-desc"
              v-if="$store.state.slide.titleDesc"
            >
              {{ this.$store.state.slide.titleDesc }}
            </p>

            <div
              class="audio-control-slide"
              v-if="
                $store.state.slide.audioLink
                  && $store.state.slide.audioPlayOnAudience
                  && $store.state.slide.id
              "
            >
              <AudioControl />
            </div>
          </div>
          <transition name="slide-fade">
            <div v-if="$store.state.slide.quizStatus == QuizStatuses.COUNTDOWN_5S_SCREEN && !result.id" class="text-center step-4">
              <div v-if="$store.state.slide.image" class="countdown-has-image">
                <img :src="$store.state.slide.image.large" alt>
              </div>

              <div id="countdown" :class="{'countdown-bg': !$store.state.slide.image}">
                <div id="countdown-number" />
                <svg v-show="!$store.state.slide.image">
                  <circle r="107" cx="120" cy="120" />
                </svg>
              </div>
            </div>
          </transition>
          <transition name="slide-fade">
            <div
              v-if="($store.state.slide.quizStatus == QuizStatuses.QUESTION_SCREEN && !isAlreadyAnswered) || $store.state.slide.quizStatus == QuizStatuses.RESULT_SCREEN"
              class="text-center step-4"
            >
              <div class="slide-img-wrapper" v-if="$store.state.slide.image">
                <img :src="$store.state.slide.image.large" alt class="slide-img">
              </div>
              <div class="progress-bar-time-answer-count">
                <div
                  class="max-point"
                  v-if="$store.state.slide.fastAnswerGetMorePoint"
                >
                  {{ $store.state.slide.maxPoint }}{{ $t("pointShortcut") }}
                </div>
                <div
                  class="min-point"
                  v-if="$store.state.slide.fastAnswerGetMorePoint"
                >
                  {{ $store.state.slide.minPoint }}{{ $t("pointShortcut") }}
                </div>

                <ProgressBarQuiz />
              </div>
              <QuizForm :result="result" />
            </div>
          </transition>

          <div v-if="result.id && !$store.state.presentation.audiencePacing">
            <AlreadyAnswer
              v-if="
                $store.state.slide.quizStatus == QuizStatuses.LOBBY_SCREEN
                  || $store.state.slide.quizStatus == QuizStatuses.RULE_SCREEN
                  || $store.state.slide.quizStatus == QuizStatuses.COUNTDOWN_5S_SCREEN
                  || ($store.state.slide.quizStatus == QuizStatuses.QUESTION_SCREEN && isAlreadyAnswered)
              "
            />
          </div>
        </div>
      </div>
      <div
        class="text-center"
        v-if="!$store.state.presentation.audiencePacing && !$store.state.presentation.presenting && !isAudienceFormShowing"
      >
        {{ $t("quizIsNotOpen") }}
        <a
          class="link-reload"
          @click="reloadPage()"
          :class="{'white': $store.state.slide.textColour == '#ffffff'}"
        >{{ $t("reloadTextLink") }}</a>
      </div>
    </div>
    <div v-if="!loading" class="text-center padding">
      <Loading style="margin: 0 auto;" />
    </div>
  </div>
</template>
<script>
// components
import QuizForm from '@/components/quiz/QuizForm.vue'
import QuizCounter from '@/components/common/QuizCounter.vue'

// containers
import QuizCounterContainer from '@/containers/common/QuizCounter'

import data from '@/assets/data/all.json'

import Config from '@/config'
import { EmojiIndex } from 'emoji-mart-vue-fast'
import Util from '@/util'
import Loading from '@/components/Loading'
import EventBus from '@/eventBus'
import ProgressBarQuiz from '@/components/ProgressBarQuiz'
import AudioControl from '@/components/AudioControl.vue'
import QuizJoinGameForm from '@/components/QuizJoinGameForm.vue'
import AlreadyAnswer from '@/components/quiz/AlreadyAnswer'
import storage from '@/services/storage'
import { mapState } from 'vuex'
import QuizStatuses from '@/constants/QuizStatuses'

export default {
  components: {
    AlreadyAnswer,
    Loading,
    QuizForm,
    ProgressBarQuiz,
    AudioControl,
    QuizJoinGameForm,
    QuizCounter: QuizCounterContainer(QuizCounter),
  },
  data() {
    return {
      openEmoji: false,
      submiting: false,
      loading: false,
      result: {},
      timeAnswer: 0,
      interval: null,
      timeLeft: 0,
      error: false,
      audienceName: this.$store.state.audienceName,
      intervalCountdownCycle: null,
      emojiIndex: null,
      requestFrame: null,
      editTeamQuiz: false,
      isAlreadyAnswered: false,
    }
  },

  computed: {
    ...mapState({
      chosenTeam: (state) => {
        return state.presentation.teamData.find((team) => team.id === state.audienceQuizTeam) || {}
      },
      quizStatus: (state) => state.slide.quizStatus,
      audienceId: (state) => state.audienceId,
      presentation: (state) => state.presentation,
    }),
    isAudienceFormShowing() {
      if (this.$store.state.presentation.teamPlay) {
        return (
          !this.$store.state.audienceName ||
          !this.$store.state.isAudienceEmojiDisabled ||
          !this.$store.state.audienceQuizTeam
        )
      }
      return (
        !this.$store.state.audienceName ||
        !this.$store.state.isAudienceEmojiDisabled
      )
    },
  },
  watch: {
    '$store.state.presentation.presenting': function handlePresentingChange() {
      if (!this.$store.state.presentation.presenting) {
        if (this.interval) {
          clearInterval(this.interval)
          this.interval = null
        }
      }
    },
    '$store.state.slide.quizStatus': function handleQuizStatusChange() {
      if (this.$store.state.slide.quizStatus === QuizStatuses.LOBBY_SCREEN) {
        if (this.requestFrame) {
          cancelAnimationFrame(this.requestFrame)
          this.requestFrame = null
        }
      }

      if (this.$store.state.slide.quizStatus === QuizStatuses.RESULT_SCREEN) {
        if (this.isAlreadyAnswered) {
          setTimeout(() => {
            EventBus.$emit('show-full-progess-bar-quiz')
          })
        } else {
          this.isAlreadyAnswered = true
        }
      }
    },
  },
  created() {
    this.QuizStatuses = QuizStatuses
  },
  mounted() {
    const self = this
    this.emojiIndex = new EmojiIndex(data)

    EventBus.$on('quizGetResult', () => {
      this.result = {
        correct: false,
        timeout: true,
        notPlay: true,
      }

      EventBus.$emit('show-full-progess-bar-quiz')
    })

    if (this.$store.state.audienceName) {
      if (!this.$store.state.presentation.teamPlay || this.$store.state.audienceQuizTeam) {
        try {
          const slideId = this.$store.state.slide.id
          const presentationId = this.$store.state.presentation.id
          const answeredSlideIds = storage.getValueByPresentation(presentationId, 'answeredSlideIds', [])
          if (answeredSlideIds.includes(slideId)) {
            this.isAlreadyAnswered = true
            this.getResult()
            EventBus.$emit('show-full-progess-bar-quiz')
          } else {
            this.isAlreadyAnswered = false
            this.result = {
              id: null,
              status: 4,
            }
            this.loading = true
            if (this.$store.state.slide.quizStatus === QuizStatuses.LOBBY_SCREEN) {
              this._updateAudienceAnswer(false)
            }

            if (this.$store.state.slide.quizStatus === QuizStatuses.RESULT_SCREEN) {
              this.result = {
                correct: false,
                timeout: true,
                notPlay: true,
              }

              EventBus.$emit('show-full-progess-bar-quiz')
            }
          }
          if (
            answeredSlideIds
            && !answeredSlideIds.length
            && this.$store.state.presentation.teamPlay
          ) {
            this.editTeamQuiz = true
          }
        } catch {
          this.getResult()
        }
        this.reCountDown()
        this._startCountDownCycle()
      } else {
        this.loading = true
      }
    } else {
      this.loading = true
    }

    EventBus.$on('start-countdown-pick-answer', () => {
      self._startCountDownTimeToAnswer()
    })

    EventBus.$on('quiz-waiting-result', (payload) => {
      self.timeAnswer = payload.timeAnswer
      self.timeLeft = payload.timeLeft
      self.result = payload.answer
      if (!payload.notSubmit) {
        self._updateAudienceAnswer(true)
      }
      self.loading = true
    })

    EventBus.$on('quiz-stop-submit', () => {
      clearInterval(self.interval)
      self.interval = null
    })
    EventBus.$on('startQuizScreenTwo', () => {
      this._startCountDownCycle()
    })

    EventBus.$on('quizTimeout', () => {
      if (this.$store.state.audienceName && !this.result.id) {
        this._createTimeupAnswer()
      }
    })

    EventBus.$on('acceptTypeAnswer', (data) => {
      if (this.$store.state.slide.id == data.slideId) {
        window.location.reload()
      }
    })

    this.handleCacheImage()
  },
  destroyed() {
    EventBus.$off('start-countdown-pick-answer')
    EventBus.$off('quiz-stop-submit')
    EventBus.$off('startQuizScreenTwo')
    EventBus.$off('quiz-waiting-result')
    EventBus.$off('quizTimeout')
    EventBus.$off('quizGetResult')
    EventBus.$off('acceptTypeAnswer')

    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }

    if (this.requestFrame) {
      cancelAnimationFrame(this.requestFrame)
      this.requestFrame = null
    }
  },
  methods: {
    async changeQuizTeam() {
      storage.updateValueByPresentation(this.presentation.id, 'audienceId', this.audienceId)
      this.$http.post(Config.api.leaveQuizTeam, {
        c: this.$store.state.presentation.uniqueAccessCode,
        a: this.audienceId,
        t: this.$store.state.audienceQuizTeam,
      }).then(() => {}, () => {})
      this.$store.state.audienceQuizTeam = null
      storage.setValueByPresentation(this.$store.state.presentation.id, 'audienceQuizTeam', null)

      Util.gaTrackEvent(
        'Quiz Team',
        'Audience change team',
        'Audience change team',
      )
    },
    async _createTimeupAnswer() {
      if (!this.$store.state.audienceName || this.result.id) return
      const {
        id: presentationId,
        uniqueAccessCode,
      } = this.$store.state.presentation

      this.result = {
        slide: 5214,
        vote: [],
        timeout: true,
        status: 3,
        typeCorrectAnswer: 1,
        point: 0,
        id: 1,
      }

      storage.updateValueByPresentation(this.presentation.id, 'audienceId', this.audienceId)
      const payload = {
        presentation: presentationId,
        slide: this.$store.state.slide.id,
        audience: this.audienceId,
        accessCode: uniqueAccessCode,
        vote: [],
        timeAnswer: this.$store.state.slide.timeToAnswer,
        audienceName: this.$store.state.audienceName,
        audienceEmoji: this.$store.state.audienceEmoji,
        point: 0,
        config: {
          timeToAnswer: this.$store.state.slide.timeToAnswer,
          quizTimestamp: this.$store.state.slide.quizTimestamp,
          multipleChoice: this.$store.state.slide.multipleChoice,
          isCorrectGetPoint: this.$store.state.slide.isCorrectGetPoint,
          stopSubmission: this.$store.state.slide.stopSubmission,
          fastAnswerGetMorePoint: this.$store.state.slide
            .fastAnswerGetMorePoint,
          SlideOptions: [],
        },
      }

      if (this.$store.state.presentation.teamPlay) {
        payload.audienceTeam = this.$store.state.audienceQuizTeam
      }

      const res = await this.$http.post(Config.api.createAnswer, payload)

      this.result = res.body
      const answeredSlideIds = storage.getValueByPresentation(
        presentationId,
        'answeredSlideIds',
        [],
      )
      answeredSlideIds.push(this.$store.state.slide.id)
      storage.setValueByPresentation(
        presentationId,
        'answeredSlideIds',
        answeredSlideIds,
      )
    },

    handleCacheImage() {
      const arr = []

      if (this.$store.state.slide.image) {
        arr.push(this.$store.state.slide.image.large)
      }

      this.$store.state.slide.SlideOptions.forEach((item) => {
        if (item.imageCropped) {
          arr.push(item.imageCropped)
        }
      })

      const preloadImages = (array) => {
        if (!preloadImages.list) {
          preloadImages.list = []
        }
        const { list } = preloadImages
        for (let i = 0; i < array.length; i++) {
          const img = new Image()
          img.onload = () => {
            const index = list.indexOf(this)
            if (index !== -1) {
              // remove image from the array once it's loaded
              // for memory consumption reasons
              list.splice(index, 1)
            }
          }
          list.push(img)
          img.src = array[i]
        }
      }

      preloadImages(arr)
    },
    clickOutSideEmoji() {
      if (this.openEmoji) {
        this.openEmoji = false
      }
    },
    _startCountDownCycle() {
      setTimeout(() => {
        if (this.$store.state.slide.quizStatus !== 3) return
        const self = this
        const countdownNumberEl = document.getElementById('countdown-number')
        if (!countdownNumberEl) return
        let countdown = 5
        countdownNumberEl.textContent = countdown
        this.intervalCountdownCycle = setInterval(() => {
          countdown--
          countdownNumberEl.textContent = countdown
          if (!countdown || countdown < 1) {
            window.clearInterval(self.intervalCountdownCycle)
            self.intervalCountdownCycle = null
          }
        }, 1000)
      }, 200)
    },
    reCountDown() {
      if (this.$store.state.slide.quizStatus === QuizStatuses.QUESTION_SCREEN) {
        this.$http.get(Config.api.getTimestamp).then(
          (res) => {
            if (this.$store.state.slide.quizTimestamp && this.$store.state.slide.quizTimestamp.length) {
              const currentTime =
                (parseInt(
                  this.$store.state.slide.quizTimestamp[
                    this.$store.state.slide.quizTimestamp.length - 1
                  ],
                  10,
                ) +
                  this.$store.state.slide.timeToAnswer * 1000 -
                  res.body.timeStamp) /
                1000
              if (currentTime > 0) {
                this.$store.state.countdownTimeToAnswer = currentTime
                this._startCountDownTimeToAnswer()
                EventBus.$emit('restart-progess-bar-quiz')
              }
            }
          },
          () => {},
        )
      }
    },
    getTimeCount(second) {
      return Util.getTimeCount(second, this)
    },
    reloadPage() {
      window.location.reload()
    },
    onChangeAudienceName() {
      this.error = false
    },
    async getResult() {
      storage.updateValueByPresentation(this.presentation.id, 'audienceId', this.audienceId)
      const payload = {
        slideId: this.$store.state.slide.id,
        audience: this.audienceId,
        presentationId: this.$store.state.presentation.id,
        config: {
          timeToAnswer: this.$store.state.slide.timeToAnswer,
          quizTimestamp: this.$store.state.slide.quizTimestamp,
          multipleChoice: this.$store.state.slide.multipleChoice,
          isCorrectGetPoint: this.$store.state.slide.isCorrectGetPoint,
          stopSubmission: this.$store.state.slide.stopSubmission,
          fastAnswerGetMorePoint: this.$store.state.slide
            .fastAnswerGetMorePoint,
          otherCorrectQuiz: this.$store.state.slide.otherCorrectQuiz,
          correctQuizTypeAnswer: this.$store.state.slide.correctQuizTypeAnswer,
        },
        type: this.$store.state.slide.type,
        slideType: this.$store.state.slide.slideType,
      }
      if (this.$store.state.presentation.teamPlay) {
        payload.teamPlay = true
        payload.teamScoringRule = this.$store.state.presentation.teamScoringRule
        payload.teamId = this.$store.state.audienceQuizTeam
      }
      const optionList = []
      this.$store.state.slide.SlideOptions.forEach((dataOption) => {
        optionList.push({
          id: dataOption.id,
          correct: dataOption.correct,
        })
      })
      payload.config.SlideOptions = optionList
      this.$http.post(Config.api.quizResult, payload).then(
        (res) => {
          if (res.body.id) {
            this._updateAudienceAnswer(true)
          } else {
            this.isAlreadyAnswered = false
            this._updateAudienceAnswer(false)
            if (this.$store.state.slide.quizStatus === QuizStatuses.RESULT_SCREEN) {
              res.body.timeout = true
            }
          }
          this.result = res.body
          this.loading = true
        },
        () => {},
      )
    },

    async _updateAudienceAnswer(answer) {
      storage.updateValueByPresentation(this.presentation.id, 'audienceId', this.audienceId)
      this.$http
        .post(Config.api.joinPresentation, {
          a: this.audienceId,
          n: this.$store.state.audienceName,
          e: this.$store.state.audienceEmoji,
          c: this.$store.state.presentation.uniqueAccessCode,
          q: true,
          i: this.$store.state.slide.id,
          t: this.$store.state.audienceQuizTeam,
          r: answer,
        })
        .then(
          () => {},
          () => {},
        )
    },
    _startCountDownTimeToAnswer() {
      const self = this
      let countTimeToAnswer = 0
      let secondTime = 0
      const startTime =
        new Date().getTime() + self.$store.state.countdownTimeToAnswer * 1000

      countTimeToAnswer = parseInt(
        (startTime - new Date().getTime()) / 1000,
        10,
      )

      function step(timestamp) {
        const timeRun = parseInt(timestamp / 1000, 10)
        if (secondTime !== timeRun) {
          secondTime = timeRun
          countTimeToAnswer = parseInt(
            (startTime - new Date().getTime()) / 1000,
            10,
          )
          self.$store.state.countdownTimeToAnswer--

          if (countTimeToAnswer === 0) {
            setTimeout(() => {
              if (!self.result.id) {
                self.result.timeout = true
                self._createTimeupAnswer()
              }
              // self.$store.state.slide.quizStatus = 5
            }, 1000)
          }
        }

        if (countTimeToAnswer > 0 && !self.result.id) {
          self.requestFrame = window.requestAnimationFrame(step)
        } else {
          self.requestFrame = null
        }
      }

      self.requestFrame = window.requestAnimationFrame(step)
    },

    handleJoinGame() {
      this.reCountDown()
      this._startCountDownCycle()
      if (this.$store.state.presentation.teamPlay) {
        this.editTeamQuiz = true
      }
    },

    addEmoji(emoji) {
      this.$store.state.audienceEmoji = emoji.native
      this.openEmoji = false
    },
    openPickEmoji() {
      this.openEmoji = !this.openEmoji
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.audio-control-slide {
  margin-bottom: 16px;
}
#countdown.countdown-bg {
  background-color: rgba(240, 240, 240, 0.6);
  border-radius: 100%;
}

.icon-step-2 {
  margin-bottom: 16px;
  .fa-stopwatch {
    font-size: 2.5em;
  }
  .fa-ban {
    color: $primary-color;

    &.white {
      color: #fff;
      opacity: 0.5;
    }
  }
}

.button-submit {
  .loading-spinner {
    margin-bottom: 0px;
  }
}

.icon-correct {
  background-color: #18b518;
  width: 50px;
  height: 50px;
  color: #fff;
  border-radius: 50%;
  line-height: 50px;
  font-size: 24px;
  border: 2px solid #fff;
  position: absolute;
  bottom: -27px;
  left: 50%;
  margin-left: -25px;

  &.error {
    background-color: red;
  }
}
.progress-bar-animation {
  background-color: #fff;
  border: 1px solid #fff;
  height: 24px;
  width: 50%;
  margin: 20px auto;
  margin-bottom: 0;
  overflow: hidden;
  .line-bar {
    height: 24px;
    width: 100%;
    background-color: $primary-color;
    animation: progress-bar 5s;
    animation-timing-function: linear;
  }
}

/* Safari 4.0 - 8.0 */
@-webkit-keyframes progress-bar {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}

/* Standard syntax */
@keyframes progress-bar {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}

.text-action {
  color: $primary-color;

  &.white {
    color: #fff;
    text-decoration: underline;
  }
}

.lobby-title {
  font-size: 22px;
}

.bubble {
  width: 140px;
  height: 140px;
  background-color: $primary-color;
  border: 1px solid #fff;
  border-radius: 50%;
  line-height: 140px;
  font-size: 50px;
  margin: 0 auto;
  margin-bottom: 32px;
  position: relative;
  margin-top: 8px;
  span {
    display: block;
    animation-iteration-count: infinite;
  }
}
.link-reload {
  margin: 16px 0;
  display: block;
  cursor: pointer;
}
.result {
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 16px;
}

.des-small {
  opacity: 0.8;
}
@-webkit-keyframes leaves {
  0% {
    -webkit-transform: scale(1);
  }
  100% {
    -webkit-transform: scale(1.2);
  }
}

@keyframes leaves {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2);
  }
}
.pick-emoji {
  position: relative;
  cursor: pointer;
  width: fit-content;
  -webkit-tap-highlight-color: transparent;

  .emoji-mart {
    position: absolute;
    top: 90px;
    left: 0;
    z-index: 110;
  }
}

.emoji-picked {
  font-size: 80px;
  margin: 16px;
}

.no-fast-answer {
  margin-bottom: 8px;
}

.item-input {
  position: relative;
  margin-bottom: 16px;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
// .slide-fade-leave-active {
//   transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
// }
.slide-fade-enter
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(-50px);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateX(50px);
  opacity: 0;
}

.step-4 {
  img {
    max-width: 100%;
    margin: 0 auto;
  }

  h2 {
    word-break: break-word;
    word-wrap: normal;
  }
}

.full-bar {
  background-color: #f1f1f1;
  border: 1px solid #fff;
}

.bar-new-1 {
  background: #f1f1f1;
  height: 12px;
  width: 100%;
}

.bar-new-2 {
  animation-name: progress-bar;
  animation-timing-function: linear;
  background: #4f9af2;
  box-sizing: border-box;
  height: 100%;
}

@keyframes progress-bar {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}

.progress-bar-time-answer-count {
  position: relative;
  margin-bottom: 16px;
  padding-top: 20px;
  border: 1px solid transparent;

  .bar-1 {
    height: 10px;
    background-color: #f1f1f1;
    border: 1px solid #fff;
    overflow: hidden;
  }

  .bar-2 {
    height: 10px;
    background-color: $primary-color;
    border: 1px solid #fff;
    width: 0%;
    position: absolute;
    bottom: 0;
    left: 0;
    transition-timing-function: ease-in;
    /* Quick on the way out */
    transition: 0.2s;
  }

  .max-point {
    position: absolute;
    left: 0;
    top: -2px;
    font-weight: bold;
  }

  .min-point {
    position: absolute;
    right: 0;
    top: -2px;
    font-weight: bold;
  }
}

.avatar-bubble {
  position: relative;
  width: 140px;
  height: 140px;
  margin: 0 auto 32px;
  span {
    position: absolute;
    top: 11px;
    left: 0;
    width: 140px;
    height: 140px;
    font-size: 100px;
  }
}

.link-reload {
  &.white {
    text-decoration: underline;
    color: #fff;
  }
}

.slide-img-wrapper {
  width: auto;
  margin: 0 auto;
  overflow: hidden;
  padding-bottom: 0;
  display: block;

  .slide-img {
    margin-bottom: 16px;
  }
}
.countdown-has-image {
  img {
    max-width: 100%;
    display: block;
    max-height: 250px;
  }
}

.change-team {
    text-decoration: underline;
    cursor: pointer;
    color: $primary-color;
}
</style>
